import React from "react";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css"; // Make sure to import the CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>
              Agile Labs leverages AI, data, and cloud technology to deliver tailored solutions that drive innovation,
              efficiency, cost savings, and competitive advantage.
            </p>
          </div>
          <div className="footer-section">
            <h3>Product & Service Quotes</h3>
            <p>
              Email <a href="mailto:network@agilelabs.ai?subject=Quote%20Request%20for%20Product%20/%20Services">network@agilelabs.ai</a> for a personalized quote for product / services.
            </p>
            <p>
              Call <a href="tel:+16505973601">+1 (650) 597-3601</a> to request immediate service estimates.
            </p>
          </div>
          <div className="footer-section">
            <h3>Find Us</h3>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-contact-icon" />
              <span>450 Century Pkwy, Ste 250, Allen, Texas 75013</span>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faPhone} className="footer-contact-icon" />
              <a href="tel:+16505973601">+1 (650) 597-3601</a>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="footer-contact-icon" />
              <a href="mailto:network@agilelabs.ai?subject=Quote%20Request%20for%20Product%20/%20Services">network@agilelabs.ai</a>
            </div>
          </div>
        </div>
      </Container>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Agilelabs AI. All Rights Reserved.</p>
        <p className="footer-trademark">“WORLD’S ONLY AI MARKETPLACE™” — USPTO Notice of Allowance issued.</p>
      </div>
    </footer>
  );
};

export default Footer;
